import React, { ChangeEvent, forwardRef } from "react";
import styles from "./input.module.scss";
import Tooltip, { TooltipProps } from "../tooltip/tooltip";

interface InputClasses {
  container?: string;
  label?: string;
  input?: string;
}

export interface InputProps {
  label?: string;
  placeholder?: string;
  value?: string | number;
  onChange?: (value: any) => void;
  maxLength?: number;
  disabled?: boolean;
  classes?: InputClasses;
  type?: "text" | "number" | "password";
  hasError?: boolean;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  tooltip?: TooltipProps;
  onFocus?: (e: React.FocusEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
}

const Input = forwardRef<HTMLInputElement, InputProps>(
  (
    {
      label,
      placeholder,
      value,
      onChange,
      maxLength,
      disabled = false,
      classes = {},
      type = "text",
      hasError = "",
      onKeyDown,
      tooltip,
      onFocus,
      onBlur,
    },
    ref,
  ) => {
    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
      const newValue = e.target.value;
      if (onChange) {
        onChange(newValue);
      }
    };

    return (
      <div className={`${styles.container} ${classes.container || ""}`}>
        {label && (
          <label className={`${styles.title} ${classes.label || ""}`}>
            {label}
            {tooltip && <Tooltip {...tooltip} />}
          </label>
        )}
        <input
          className={`${styles.input} ${value ? styles.filled : ""} ${hasError ? styles.error : ""} ${classes.input || ""}`}
          placeholder={placeholder}
          value={value}
          onChange={handleChange}
          maxLength={maxLength}
          disabled={disabled}
          type={type}
          ref={ref}
          onKeyDown={onKeyDown}
          onFocus={onFocus}
          onBlur={onBlur}
        />
      </div>
    );
  },
);

export default Input;
